var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.76328 17.4283C9.03995 17.1599 8.39827 16.6349 7.98994 15.8883C7.05661 14.1849 7.62827 11.9683 9.28494 10.9416L12.0149 9.24994C13.6599 8.22327 15.7833 8.78326 16.7166 10.4749C17.6499 12.1783 17.0783 14.3949 15.4216 15.4216L15.0599 15.6783",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.295 11.5251C20.0183 11.7935 20.66 12.3185 21.0683 13.0651C22.0016 14.7685 21.43 16.9851 19.7733 18.0118L17.0433 19.7035C15.3983 20.7301 13.275 20.1701 12.3416 18.4785C11.4083 16.7751 11.98 14.5585 13.6366 13.5318L13.9983 13.2751",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 26.1666C20.9433 26.1666 26.1666 20.9432 26.1666 14.4999C26.1666 8.0566 20.9433 2.83325 14.5 2.83325C8.05666 2.83325 2.83331 8.0566 2.83331 14.4999C2.83331 20.9432 8.05666 26.1666 14.5 26.1666Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.08d532603b6506a3bbe14605fd641718.svg";
export { ForwardRef as ReactComponent };